/**
 * Returns today's date in YYYY-MM-DD (local timezone).
 * Use for default values in date inputs and API params.
 */
export function getTodayString(): string {
  return new Date().toISOString().slice(0, 10);
}
